import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = ['country'];

  change() {
    window.location.search = '?country_id=' + this.countryTarget.value;
  }
}
